module.exports = __webpack_public_path__ + "img/pick4.4d7d7a12.png";